import {
  children as solidChildren,
  createMemo,
  getOwner,
  useContext as solidUseContext,
} from "solid-js";

namespace USolid {
  // For use when destructuring children, children helper name will collide
  export const children = solidChildren;
  // useContext is a useful name in namespaces, use this when name collides
  export const useContext = solidUseContext;

  export const runMemo = <T,>(fn: () => T) => {
    const owner = getOwner();
    return owner ? createMemo(fn)() : fn();
  };
}

export default USolid;
